import script from "./CreatorChatMainComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatMainComponent.vue?vue&type=script&setup=true&lang=js"

import "./CreatorChatMainComponent.vue?vue&type=style&index=0&id=c5709b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5709b1e"]])

export default __exports__